// Which translated editions Google should index (search audit 2026-11-02, Szymon's go 2026-11-03:
// "apply the restructure"). Every edition is still generated and served, so undoing a cut is a
// one-line change here; a cut edition gets `noindex, follow`, leaves the sitemap and the hreflang
// sets, and internal links point to the English page instead.
//
// - Full: every page in that language.
// - Tools tier: free tools, templates, learn, research, blog, tutorials and core pages stay
//   indexed; the English-buyer sales sections below are cut (they earned 42 of 835 clicks there).
// - Dropped: no indexed pages (fi, hu, nl, sv, tl earned 29 of 835 clicks, Oct 3-31).
// - Changelog is English-only in every language (1,944 translated URLs, 1 English click).
// Plain JS so data/locales.ts (app) and scripts/*.mjs (build) share one policy.

export const fullLocaleCodes = ['en', 'es', 'de', 'it', 'fr', 'pt'];

export const droppedLocaleCodes = ['fi', 'hu', 'nl', 'sv', 'tl'];

// Every other locale in data/locales.ts is tools tier.
export const toolsTierCutSections = [
  '/solutions',
  '/compare',
  '/switch',
  '/alternatives',
  '/features',
  '/integrations',
];

export const englishOnlySections = ['/changelog'];

const full = new Set(fullLocaleCodes.map((code) => code.toLowerCase()));
const dropped = new Set(droppedLocaleCodes.map((code) => code.toLowerCase()));

const inSection = (path, sections) =>
  sections.some((section) => path === section || path.startsWith(`${section}/`));

const basePathname = (routePath) => {
  const pathname = String(routePath || '/').split(/[?#]/)[0].replace(/\/+$/, '');
  return pathname || '/';
};

export const isDroppedLocale = (localeCode) => dropped.has(String(localeCode || '').toLowerCase());

// routePath is the unprefixed (English) path of a page that has translated editions.
export const isEditionIndexable = (routePath, localeCode) => {
  const code = String(localeCode || 'en').toLowerCase();
  if (code === 'en') return true;
  if (dropped.has(code)) return false;
  const path = basePathname(routePath);
  if (inSection(path, englishOnlySections)) return false;
  if (full.has(code)) return true;
  return !inSection(path, toolsTierCutSections);
};
